import environment from "environment";
import { Connect } from "./connect";

export class MsIntegrationConnect extends Connect {
  constructor() {
    const { apiKey, apiMsIntegration, apiUrl } = environment;
    const login = { idToken: sessionStorage.getItem("idToken") };
    super(apiMsIntegration, "acc-integration", {
      apiKey,
      token: login.idToken,
      Origin: apiUrl
    });
  }

  async getTotalPayment(campaignId: any): Promise<any> {
    const response: any = await this.request({
      method: "get",
      service: `overdue-patrimonial?campaignId=${campaignId}`
    });

    return response.data;
  }
}
